import React from "react";

import { Row, Col, Input, Pagination } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import { DatePicker, RangeDatePicker } from "jalali-react-datepicker";

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/InsuranceKnowledge/Approvals/Approvals.css";

const continueStyle = {
  fontFamily: "IranSansUltraLight",
  fontSize: ".9em",
  color: "#ed1c24",
  opacity: "90%",
};
const continueStyleTablet = {
  fontFamily: "IranSansUltraLight",
  fontSize: ".8em",
  color: "#ed1c24",
  opacity: "90%",
};
const continueStyleMobile = {
  fontFamily: "IranSansUltraLight",
  fontSize: ".75em",
  color: "#ed1c24",
  opacity: "90%",
};
const dateStyle = {
  fontFamily: "IranSansLight",
  fontSize: ".9em",
  color: "#3d5563",
};
const dateStyleTablet = {
  fontFamily: "IranSansLight",
  fontSize: ".8em",
  color: "#3d5563",
};
const dateStyleMobile = {
  fontFamily: "IranSansLight",
  fontSize: ".75em",
  color: "#3d5563",
};
const titleStyle = {
  fontFamily: "IranSans",
  fontSize: ".8em",
  direction: "rtl",
  textAlign: "right",
  color: "#186491",
};
const titleStyleTablet = {
  fontFamily: "IranSans",
  fontSize: ".75em",
  direction: "rtl",
  textAlign: "right",
  color: "#186491",
};
const titleStyleMobile = {
  fontFamily: "IranSans",
  fontSize: ".7em",
  direction: "rtl",
  textAlign: "right",
  color: "#186491",
};
const numberStyle = {
  fontFamily: "IranSans",
  color: "#6e6e6e",
};

const ApprovalsList = (props) => {
  return props.size === "laptopdesktop" ? (
    <div>
      <Row>
        <Col span={22}>
          <div
            style={{
              borderRadius: "10px",
              backgroundColor: props.color,
              padding: "5px",
            }}
          >
            <Row>
              <Col span={4}>
                <Center>
                  <div>
                    <a
                    onClick={()=>{
                        console.log(props)
                        props.history.push(`/Approvalsinside/${props.id}`)}}
                    
                      style={continueStyle}
                    >
                      ادامه
                    </a>
                  </div>
                </Center>
              </Col>
              <Col span={4}>
                <Center>
                  <div style={{ paddingTop: "5px" }}>
                    <p style={dateStyle}>{props.date}</p>
                  </div>
                </Center>
              </Col>
              <Col span={15} style={{ direction: "rtl", textAlign: "right" }}>
                <strong style={titleStyle}>{props.title}</strong>
              </Col>
              <Col span={1}></Col>
            </Row>
          </div>
          <Margin top={2}></Margin>
        </Col>
        <Col span={2}>
          <Center>
            <div style={{ marginTop: "5px" }}>
              <p style={numberStyle}>
                <strong>{props.number}</strong>
              </p>
            </div>
          </Center>
        </Col>
      </Row>
    </div>
  ) : props.size === "tablet" ? (
      <div>
        <Row>
          <Col span={22}>
            <div
              style={{
                borderRadius: "10px",
                backgroundColor: props.color,
                padding: "5px",
              }}
            >
              <Row>
                <Col span={4}>
                  <Center>
                    <div>
                      <a
                        onClick={() => {
                          console.log(props)
                          props.history.push(`/Approvalsinside/${props.id}`)
                        }}

                        style={continueStyleTablet}
                      >
                        ادامه
                    </a>
                    </div>
                  </Center>
                </Col>
                <Col span={4}>
                  <Center>
                    <div style={{ paddingTop: "5px" }}>
                      <p style={dateStyleTablet}>{props.date}</p>
                    </div>
                  </Center>
                </Col>
                <Col span={15} style={{ direction: "rtl", textAlign: "right" }}>
                  <strong style={titleStyleTablet}>{props.title}</strong>
                </Col>
                <Col span={1}></Col>
              </Row>
            </div>
            <Margin top={2}></Margin>
          </Col>
          <Col span={2}>
            <Center>
              <div style={{ marginTop: "5px" }}>
                <p style={numberStyle}>
                  <strong>{props.number}</strong>
                </p>
              </div>
            </Center>
          </Col>
        </Row>
      </div>
  ) : (
        <div>
          <Row>
            <Col span={22}>
              <div
                style={{
                  borderRadius: "10px",
                  backgroundColor: props.color,
                  padding: "5px",
                }}
              >
                <Row>
                  {/* <Col span={4}>
                    <Center>
                      <div>
                        <a
                          onClick={() => {
                            console.log(props)
                            props.history.push(`/Approvalsinside/${props.id}`)
                          }}

                          style={continueStyleMobile}
                        >
                          ادامه
                    </a>
                      </div>
                    </Center>
                  </Col> */}
                  <Col span={6}>
                    <Center>
                      <div style={{ paddingTop: "5px" }}>
                        <p style={dateStyleMobile}>{props.date}</p>
                      </div>
                    </Center>
                  </Col>
                  <Col span={2}></Col>
                  <Col span={15} style={{ direction: "rtl", textAlign: "right" }}>
                    <strong style={titleStyleMobile}>{props.title}</strong>
                  </Col>
                  <Col span={1}></Col>
                </Row>
                <Row>
                  <Col span={1}></Col>
                  <Col span={6}>
                    <a
                      onClick={() => {
                        console.log(props)
                        props.history.push(`/Approvalsinside/${props.id}`)
                      }}

                      style={continueStyleMobile}
                    >
                      ادامه
                    </a>
                  </Col>
                </Row>
              </div>
              <Margin top={2}></Margin>
            </Col>
            <Col span={2}>
              <Center>
                <div style={{ marginTop: "5px" }}>
                  <p style={numberStyle}>
                    <strong>{props.number}</strong>
                  </p>
                </div>
              </Center>
            </Col>
          </Row>
        </div>
  );
};

export default ApprovalsList;
